import { useEffect, useState } from 'react';
import FontFaceObserver from 'fontfaceobserver';

function useFontsLoaded() {
  const [fontsLoaded, setFontsLoaded] = useState<boolean>(false);

  useEffect(() => {
    const fontBold = new FontFaceObserver('Roboto Bold');
    const fontMedium = new FontFaceObserver('Roboto Medium');
    const fontRegular = new FontFaceObserver('Roboto Regular');

    Promise.all([fontMedium.load(), fontRegular.load(), fontBold.load()]).then(() => {
      setFontsLoaded(true);
    });
  }, []);

  return fontsLoaded;
}

export default useFontsLoaded;
